import { Vehicle } from '@esportal/portal-service';
import React, { useEffect, useState } from 'react';
import {
	findSelectedVehicle,
	getFilteredVehicles,
	isIDcareActive,
	isLongdriveActive,
	isWarrantyActive,
} from '../../../helpers/servicesHelper';
import { useMyServicesTracker } from './use-my-services-tracker';
import { ServiceGroupType } from '../models/services-layer-types';

export const useMyServicesState = ({ vehicles, userData }: { vehicles: Vehicle[]; userData: any }) => {
	const { trackSelectedVehicleChange, trackMyServicesAccordion } = useMyServicesTracker();
	const filteredVehicles = getFilteredVehicles(vehicles);

	// SELECTED VEHICLE STATE
	const [selectedVehicle, setSelectedVehicle] = useState<Vehicle>(findSelectedVehicle(filteredVehicles));

	const handleSelectedVehicleChange = (
		e: React.SyntheticEvent<HTMLInputElement> | React.SyntheticEvent<HTMLSelectElement>,
	) => {
		const { value } = e.target as HTMLInputElement | HTMLSelectElement;
		const foundVehicle = filteredVehicles?.find((vehicle: Vehicle) => vehicle.name === value);
		if (foundVehicle) {
			trackSelectedVehicleChange(foundVehicle);
			setSelectedVehicle(foundVehicle);
		}
	};

	// ACORDION STATE
	const [accordionServices, setAccordionServices] = useState<{ id: string; isOpen: boolean }[]>([]);

	useEffect(() => {
		const services: { id: string; isOpen: boolean }[] = [];

		if (isLongdriveActive(selectedVehicle) || isWarrantyActive(selectedVehicle) || isIDcareActive(selectedVehicle)) {
			services.push({ id: ServiceGroupType.Coberturas, isOpen: false });
		}

		if (userData.portalUser.data.dealers?.pv?.commercialName) {
			services.push({ id: ServiceGroupType.Dealer, isOpen: false });
		}

		setAccordionServices(services);
	}, [selectedVehicle, userData]);

	const handleAccordionToggle = (id: ServiceGroupType) => {
		trackMyServicesAccordion(
			selectedVehicle,
			id,
			accordionServices.find((service) => service.id === id)?.isOpen ?? false,
		);
		setAccordionServices((prev) => {
			const updated = prev.map((service) => ({
				...service,
				isOpen: service.id === id ? !service.isOpen : false,
			}));

			return updated;
		});
	};

	const openIndex = accordionServices.findIndex((service) => service.isOpen);

	// Helper per saber si el accordion esta obert
	const isAccordionOpen = (id: string) => accordionServices.find((service) => service.id === id)?.isOpen ?? false;

	//Helper per saber l'index anterior del accordion seleccionat
	const isPreviousOpen = (id: string): boolean => {
		const index = accordionServices.findIndex((s) => s.id === id);
		return index === openIndex - 1;
	};

	return {
		filteredVehicles,
		selectedVehicle,
		handleSelectedVehicleChange,
		accordionServices,
		handleAccordionToggle,
		isAccordionOpen,
		isPreviousOpen,
	};
};
